<template>
  <div class="wildblumen">
    <figure class="image">
      <picture>
        <source
          media="(max-width: 768px)"
          sizes="(max-width: 1536px) 100vw, 1536px"
          srcset="
            ../assets/images/Blumenwiese-380.jpg     380w,
            ../assets/images/Blumenwiese-380@2x.jpg  760w,
            ../assets/images/Blumenwiese-768.jpg     768w,
            ../assets/images/Blumenwiese-768@2x.jpg 1536w
          "
        />
        <source
          media="(min-width: 769px"
          sizes="(min-width: 769px) 100vw, 3840px"
          srcset="
            ../assets/images/Blumenwiese-1024.jpg    1024w,
            ../assets/images/Blumenwiese-1216.jpg    1216w,
            ../assets/images/Blumenwiese-1407.jpg    1407w,
            ../assets/images/Blumenwiese-1024@2x.jpg 2048w,
            ../assets/images/Blumenwiese-1216@2x.jpg 2432w,
            ../assets/images/Blumenwiese-1407@2x.jpg 2814w,
            ../assets/images/Blumenwiese-1920.jpg    1920w,
            ../assets/images/Blumenwiese-1920@2x.jpg 1921w
          "
        />
        <img
          sizes="(max-width: 7500px) 40vw, 3000px"
          srcset="
            ../assets/images/Blumenwiese-380.jpg      380w,
            ../assets/images/Blumenwiese-380@2x.jpg   760w,
            ../assets/images/Blumenwiese-768.jpg      768w,
            ../assets/images/Blumenwiese-1024.jpg    1024w,
            ../assets/images/Blumenwiese-1216.jpg    1216w,
            ../assets/images/Blumenwiese-1407.jpg    1407w,
            ../assets/images/Blumenwiese-1024@2x.jpg 2048w,
            ../assets/images/Blumenwiese-1216@2x.jpg 2432w,
            ../assets/images/Blumenwiese-1407@2x.jpg 2814w,
            ../assets/images/Blumenwiese-1920.jpg    1920w,
            ../assets/images/Blumenwiese-1920@2x.jpg 1921w
          "
          src="../assets/images/Blumenwiese-1920.jpg"
          alt="Nahaufnahme eine Blumenwiese"
        />
      </picture>
    </figure>
    <div class="hero is-info">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-2 is-size-3-mobile">Blühbuffet</h1>
          <p class="subtitle is-4 is-size-5-mobile">
            Mehr als nur ein Augenschmaus.
          </p>
        </div>
      </div>
    </div>
    <div class="section is-medium">
      <div class="container">
        <div class="columns">
          <div class="column is-size-6 is-size-7-mobile">
           Mit der Wilden Pracht haben wir uns zum Ziel gesetzt, einen Lebensraum und ein Nahrungsangebot für Insekten zu schaffen. Aber warum ist das überhaupt notwendig? Und wo leben und futtern die Tierchen, wenn es keine Blühwiese gibt?<br><br>Die meisten unserer Wilde Pracht-Blühwiesen liegen an sogenannten Knicks, grünen Zäunen aus Sträuchern und Bäumen, die die einzelnen Felder voneinander abtrennen. Insekten und Wildtiere haben dort einen riesigen Rückzugs- und Lebensraum, trotzdem ist sich unser Bauer Christian sicher, dass sie nur darauf warten, auf die Blühwiesen zu kommen, wo sie natürlich noch viel mehr Futter und ein wundervolles buntes Zuhause haben.
          </div>
          <div class="column is-size-6 is-size-7-mobile">
            Mit ihren Blüten locken die Blumen die Insekten an, die dort auch für die Vermehrung der Blumen sorgen. Die Bienen fliegen von Blüte zu Blüte und bestäuben sie. Daraufhin bildet die Pflanze Samen, die der Wind verteilt.<br><br>Wir von der Wilden Pracht beziehen unsere Blühmischung von einem Saatgutproduzenten aus der Region. Er weiß genau, welche Zusammensetzung nötig ist, damit die Blumen den ganzen Sommer über blühen. Denn zwar sieht eine bunte Wiese mit vielen unterschiedlichen Blümchen toll aus, doch ist es viel sinnvoller, wenn die Blumen nacheinander blühen, damit die kleinen Tierchen entsprechend über viele Monate eine Nahrungsquelle finden. Die Idee hinter unserer Saatmischung ist also, dass immer dann, wenn eine Blume verblüht ist, die nächste schon in voller Pracht da steht. Welche Blumen wir genau ansäen, liest du unter den <a href="https://wilde-pracht.de/faq">FAQs</a>.
          </div>
        </div>
      </div>
    </div>
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h2 class="title is-2 is-size-3-mobile">
          Lebensraum und Futterquelle.
          </h2>
        </div>
      </div>
    </div>
    <div class="section is-medium">
      <div class="container">
        <div class="columns">
          <div class="column is-size-6 is-size-7-mobile">
            Im Herbst, wenn die Blumen irgendwann verblüht sind, lassen wir sie trotzdem stehen. Dann sieht die Blühwiese zwar nicht mehr wie in einer Gartenzeitschrift aus, dafür bietet sie aber gerade jetzt einen tollen Lebensraum für die vielen kleinen Käfer, die fleißig auf ihr herumkrabbeln. Eichhörnchen und Vögel freuen sich außerdem über die verwelkten Sonnenblumen, deren Kerne sie heraussammeln und damit ein echtes Festmahl veranstalten. „Und das Hotel, das die Insekten im Sommer weitestgehend für sich allein hatten, hat die Türen dann auch für all die anderen kleineren und größeren Wildtiere geöffnet“, drückt es unser Bauer Christian aus. Damit ändern sich auch die Geräusche auf den Feld: Während es im Sommer häufig laut summt und brummt, ist im Herbst höchstens mal ein Rascheln zu hören …
          </div>
          <div class="column is-size-6 is-size-7-mobile">
            Bevor die Blühwiese in die nächste Saison startet, wird sie noch einmal gemulcht, oder das restliche Grün, wie auf Hof Appelbü, von den hauseigenen Schafen verwertet. Das ist notwendig, damit in der kommenden Blühsaison alle Pflanzen, die für die Artenvielfalt sinnvoll sind, wieder gleichberechtigt wachsen können. Würde man die Wiese sich selbst überlassen, würde sich mit der Zeit nur das Unkraut immer stärker verbreiten und den wertvollen Pflanzen ihren Lebensraum und damit auch den Tieren ihre wichtige Futterquelle nehmen.<br><br>Dir hat gefallen, was du hier liest? Dann freue dich auf unsere Bienenpost, denn dort erzählen wir dir noch viele weitere spannende Fakten aus der Blühwiesen-Welt.

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Bluehbuffet",
  metaInfo: {
    title: "Blühbuffet | Wilde Pracht",
    meta: [
      {
        name: "description",
        content:
          "Mit der Wilden Pracht schaffen wir gemeinsam mit dir einen reich gedeckten Tisch für Bienen, Hummeln und Schmetterlinge. "
      },
      { itemprop: "name", content: "Blühbuffet | Wilde Pracht" },
      { property: "og:title", content: "Blühbuffet | Wilde Pracht" },
      {
        itemprop: "description",
        content:
          "Mit der Wilden Pracht schaffen wir gemeinsam mit dir einen reich gedeckten Tisch für Bienen, Hummeln und Schmetterlinge. "
      },
      {
        property: "og:description",
        content:
          "Mit der Wilden Pracht schaffen wir gemeinsam mit dir einen reich gedeckten Tisch für Bienen, Hummeln und Schmetterlinge. "
      }
    ]
  }
};
</script>
